// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"273":"197ec2212190a1e0","496":"b9febfe26fc6b90d","533":"3e007f5a93fd5a76"}[chunkId] + ".js";
};